// @ts-nocheck
import { flow, Instance, types } from 'mobx-state-tree';
import { Role } from './models/Role';
import { getEnvironment } from './utils';
import { getBaseStore } from './BaseStore';

export const RoleStore = types
  .compose(
    getBaseStore<Instance<typeof Role>, Instance<typeof Role>>(Role, 'roleId', 'role'),
    types.model('RoleStore', {}),
  )
  .actions((self: any) => {
    const env = getEnvironment(self);

    const getRoles = flow(function*() {
      const res = yield env.api.get(`user/Roles`);
      self.setDatasFromArray(res);
    });

    return { getRoles };
  });
